var render = function render(){
  var _vm$mortgage$applican, _vm$mortgage$applican2, _vm$servicedApplicati;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "serviced-mortgage-group"
  }, [_c('div', {
    staticClass: "mortgage-result-servised serviced-mortgage-clickable",
    "class": {
      'serviced-mortgage-clickable--disabled': !_vm.servicedDebt
    },
    attrs: {
      "role": _vm.servicedDebt ? 'button' : null,
      "tabindex": _vm.servicedDebt ? 0 : -1,
      "aria-label": _vm.servicedDebt ? "Otvori\u0165 detail \xFAveru klienta ".concat(((_vm$mortgage$applican = _vm.mortgage.applicant) === null || _vm$mortgage$applican === void 0 ? void 0 : _vm$mortgage$applican.first_name) || '', " ").concat(((_vm$mortgage$applican2 = _vm.mortgage.applicant) === null || _vm$mortgage$applican2 === void 0 ? void 0 : _vm$mortgage$applican2.last_name) || '').trim() : null
    },
    on: {
      "click": _vm.openDebtDetail,
      "keydown": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        $event.preventDefault();
        return _vm.openDebtDetail.apply(null, arguments);
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
        $event.preventDefault();
        return _vm.openDebtDetail.apply(null, arguments);
      }]
    }
  }, [_c('div', {
    staticClass: "mortgage-parameters-servised"
  }, [_c('div', {
    staticClass: "servisedmortgageLeft"
  }, [_c('div', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('user-manager-handler', {
    attrs: {
      "rules": ['priority'],
      "client-info": _vm.mortgage.applicant,
      "client": "",
      "clients": ""
    }
  })], 1), _c('div', {
    staticClass: "wrap150px",
    staticStyle: {
      "text-align": "start"
    }
  }, [_vm._v(" " + _vm._s(_vm.transformDate(_vm.mortgage.nacerpana)) + " ")])]), _c('div', {
    staticClass: "servisedmortgageRight"
  }, [_c('img', {
    staticClass: "bank-logo",
    staticStyle: {
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.getBankLogoImage(_vm.servicedApplication.bank),
      "loading": "lazy",
      "alt": _vm.servicedApplication.bank
    }
  }), _vm.servicedApplication.vytvoreny_debt ? _c('div', {
    staticClass: "bold wrap150px"
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.servicedApplication.vytvoreny_debt.zostatok)) + " EUR "), _c('br'), _c('span', {
    staticClass: "opacity-30 light"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")(_vm.totalAmounts(_vm.servicedApplication))) + " EUR")])]) : _vm._e(), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" " + _vm._s((_vm$servicedApplicati = _vm.servicedApplication.sadzba_schvalena) !== null && _vm$servicedApplicati !== void 0 ? _vm$servicedApplicati : _vm.servicedApplication.sadzba_pozadovana)), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("%")])]), _c('div', {
    staticClass: "bold wrap100px d-flex align-items-center",
    staticStyle: {
      "justify-content": "center"
    }
  }, [_vm._v(" " + _vm._s(_vm._f("dotTheAmount")(_vm.servicedApplication.splatka)) + " "), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("EUR")])]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" FIX " + _vm._s(_vm.calculateFixEndDate()) + " "), _c('span', {
    staticClass: "upper-index"
  })]), _c('div', {
    staticClass: "bold wrap50px"
  }, [_vm._v(" " + _vm._s(_vm.remainingMaturityMonths)), _c('span', {
    staticClass: "upper-index"
  }, [_vm._v("MES.")])]), _c('div', {
    staticClass: "d-flex",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('application-refixation-handler', {
    attrs: {
      "mortgage": _vm.mortgage
    }
  }), _c('div', {
    staticClass: "text-cta",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('div', {
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.refinanceMortgage.apply(null, arguments);
      }
    }
  }, [_vm._v(" REFINANCOVANIE ")])])], 1)])])]), _vm.servicedDebt ? _c('service-refinancing-check', {
    attrs: {
      "mortgage": _vm.mortgage,
      "debt-id": _vm.servicedDebt.id,
      "active": _vm.servicedDebt.is_active !== false
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }